/*
 * Copyright (c) 2020. Denis Rendler <connect@rendler.me>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import PropTypes from 'prop-types';

const Select = ({ name, selectCls, childCls, initValue, updateEv, options }) => {

  options = options.map((opt, index) => {
    return <option key={index} value={opt.value} className={childCls.join(' ')}>{opt.text}</option>;
  });

  return (
    <select
      name={name}
      className={selectCls.join(' ')}
      value={initValue}
      onChange={(e) => updateEv(e.target)}
    >
      {options}
    </select>
  );
};

Select.propTypes = {
  name:         PropTypes.string.isRequired,
  selectCls:    PropTypes.array,
  childCls:     PropTypes.array,
  initValue:    PropTypes.string,
  updateEv:     PropTypes.func,
  options:      PropTypes.arrayOf(
    PropTypes.shape({
      text:     PropTypes.string.isRequired,
      value:    PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
};

Select.defaultProps = {
  selectCls: [],
  childCls: [],
  initValue: '',
  updateEv: () => {},
  options: [],
};

export default Select;
